<i18n>
{
	"fi": {
		"buttons": {
			"editYourDetails": "Muokkaa tietojasi"
		}
	}
}
</i18n>

<template>
	<div>
		<!-- Membership card -->
		<v-container class="container--narrow">
			<v-card>
				<v-img
					v-if="config._hero_image"
					aspect-ratio="1.628"
					:src="config._hero_image.url"
					gradient="rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .6) 100%"
					dark
				>
					<div
						class=""
						style="display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; height: 100%;"
					>
						<v-card-title
							class="primary--text text-right"
							style="align-self: flex-end;"
						>
							Voimassa {{ user._validity_period }}
						</v-card-title>
						<v-card-title
							class="white--text headline"
							style="margin-top: auto;"
						>
							{{ user.firstname }} {{ user.lastname }}
							<br>
							{{ user.entity_number }}
						</v-card-title>
					</div>
				</v-img>
				<template v-else>
					<v-card-title class="headline">
						{{ user.firstname }} {{ user.lastname }}
						<br>
						{{ user.entity_number }}
					</v-card-title>
				</template>
				<v-expansion-panels v-if="user._details && user._details.length">
					<v-expansion-panel>
						<v-expansion-panel-header>
							<div>
								<v-icon color="primary">
									mdi-account-details
								</v-icon>
								<span class="pl-3">
									Omat tiedot
								</span>
							</div>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<FilterableList
								v-if="user._details && user._details.length"
								:items="user._details"
								subtitle-src="label"
								title-src="value"
								:enable-click="(false)"
								:enable-search="(false)"
							/>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
				<v-divider />
				<v-card-actions>
					<v-btn
						:to="{ name: 'myAccount' }"
						color="primary"
						text
					>
						<v-icon left>
							mdi-pencil
						</v-icon>
						{{ $i18n.t('buttons.editYourDetails') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-container>

		<v-container class="container--narrow">
			<v-alert
				v-if="(user._user_restricted === true)"
				type="error"
				dense
				:icon="false"
			>
				<v-row align="center">
					<v-col class="grow">
						Jäsenmaksusi on maksamatta.
					</v-col>
					<v-col class="shrink">
						<v-btn
							outlined
							color="white"
							:to="{ name: 'invoices' }"
						>
							Laskut
						</v-btn>
					</v-col>
				</v-row>
			</v-alert>
		</v-container>
	</div>
</template>

<style scoped>
.v-expansion-panel::before {
	box-shadow: none;
}
.v-expansion-panel-content >>> .v-list {
	padding: 0;
}
.v-expansion-panel-content >>> .v-list-item {
	padding: 0;
}
.v-expansion-panel-content >>> .v-divider--inset:not(.v-divider--vertical) {
	max-width: calc(100% - 56px);
	margin-left: 56px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
	name: 'MembershipCard',
	computed: {
		...mapState([
			'config',
			'user',
		]),
	},
	mounted () {
		// this.$api.Me.doRequest()
	},
}
</script>
